// extracted by mini-css-extract-plugin
export default {"link":"Ijmi0y","image":"rsuj6s","root":"Cq9wHD","ScotchA":"BEk13G","scotchA":"BEk13G","ScotchB":"XQk8nk","scotchB":"XQk8nk"};